import { httpPublic2 } from "@/api/public";
import { logOut } from "@/redux/actions/logout";
import store from "@/redux/store";

// store.dispatch is typed as Dispatch<AnyAction> but auth actions are thunks
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dispatch: (action: any) => any = store.dispatch;

type NewIdTokenPayload = {
  id_token?: string;
  refresh_token?: string;
};

type NewIdTokenResponse = {
  AuthenticationResult: {
    AccessToken: string;
    IdToken: string;
  };
};

export const authRequestsTyped = {
  // Uses httpPublic2 (public, no auth hooks) with an explicit Authorization header so
  // tokenRefresh.ts can call this without creating a circular dependency through
  // the authenticated ky instances.
  newIdToken: function ({ data }: { data: NewIdTokenPayload }) {
    const token = localStorage.getItem("token");

    if (!token) {
      dispatch(logOut());
      throw new Error("Missing token");
    }

    return httpPublic2
      .post("v1/auth/new_id_token", {
        headers: { Authorization: token },
        json: data,
      })
      .json<NewIdTokenResponse>();
  },
};
